export const adminInputClassName =
  'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-Blue-text sm:text-sm/6 whitespace-nowrap';

export const adminSectionClassName = 'gap-2 w-full flex flex-col';

export const adminDividerClassName = 'w-ful border-b-1 border-gray-line';

// New utility classes for redesigned MOS Configuration
export const configCardClassName =
  'bg-white shadow-sm sm:rounded-lg border border-gray-200';

export const configCardContentClassName = 'px-4 py-5 sm:p-6';

export const configContainerClassName = 'w-full space-y-6';

export const configSectionTitleClassName =
  'text-lg font-semibold text-gray-900 mb-4';

export const configFieldLabelClassName =
  'block text-sm font-medium text-gray-700 mb-2';

export const configStatusChipClassName =
  'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium';

export const configListItemClassName =
  'flex items-center justify-between py-2 px-3 bg-gray-50 rounded-md border border-gray-200';

export const configRemoveButtonClassName =
  'text-gray-400 hover:text-red-600 transition-colors duration-200';

export const getNotificationTitleAndDescription = (
  type: string,
): { title: string; description: string } => {
  switch (type) {
    case 'EncompassEmailNotifications':
      return {
        title: 'Encompass',
        description: 'Configure email notifications for Encompass events.',
      };
    case 'ApplicationEmailNotifications':
      return {
        title: 'Application',
        description: 'Configure email notifications for application events.',
      };
    default:
      return {
        title: 'Unknown Notification Type',
        description: 'No description available for this notification type.',
      };
  }
};
